export default (app) => {
  if (window.location.protocol === "chrome-extension:")
    app.on("getAppVersion", -10, (q) => ({ ...q, noReload: true }));
};
